import { namespacer } from 'helpers'

const namespace = namespacer('AUTH')

export const AUTHENTICATION_FAILED = namespace('AUTHENTICATION_FAILED')
export const LOAD_AUTH_TOKEN = namespace('LOAD_AUTH_TOKEN')
export const LOAD_CURRENT_USER = namespace('LOAD_CURRENT_USER')
export const HYDRATION_ERROR = namespace('HYDRATION_ERROR')
